import { StatusContainer } from '@servicetitan/financing-utils-shared';
import { LoanDetails } from './LoanDetails';
import { SecondLookFinancingOption } from '../second-look';
import DeclinedIllustration from '../../common/illustrations/unable-to-load.svg';
import { useProviderConfig, useTurnsIntegration } from '@servicetitan/financing-workflow-shared';
import { Alert, Text } from '@servicetitan/anvil2';

export const Declined = () => {
    const { defaultWorkflowStage, declinedHeadline, declinedMessage } = useProviderConfig();
    const isExternalApplication = defaultWorkflowStage === 'external-application';
    const turnsIntegration = useTurnsIntegration();

    return (
        <>
            {turnsIntegration.isServiceDegraded && (
                <Alert status="warning" title="Unable to submit to Turns">
                    <Text>
                        We're currently unable to submit your application to Turns due to a
                        temporary service issue on our end. Please try submitting a Turns
                        application later.
                    </Text>
                </Alert>
            )}
            <StatusContainer
                headline={isExternalApplication ? '' : (declinedHeadline ?? '')}
                message={isExternalApplication ? undefined : declinedMessage}
                image={DeclinedIllustration}
            >
                {isExternalApplication ? null : <LoanDetails hideDetails />}
                <SecondLookFinancingOption />
            </StatusContainer>
        </>
    );
};
